import React from 'react';
import { motion } from 'framer-motion';
import { CalculatorIcon, PieChartIcon, BellIcon, ClockIcon } from 'lucide-react';
export function Mechanism() {
  const features = [{
    icon: CalculatorIcon,
    text: 'Fórmulas automáticas (cero matemáticas)'
  }, {
    icon: PieChartIcon,
    text: 'Gráficos que se actualizan solos'
  }, {
    icon: BellIcon,
    text: 'Alertas rojas para déficits'
  }, {
    icon: ClockIcon,
    text: 'Listo en 15 minutos'
  }];
  return <section className="py-20 px-4 bg-gradient-to-br from-purple-dark to-purple text-white relative overflow-hidden" data-id="element-163">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-164" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-light/20 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-165" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-balance" data-id="element-168">
            El Mecanismo:{' '}
            <span className="text-gold" data-id="element-169">Latina Budget Control</span>
          </h2>
          <p className="text-lg md:text-xl text-cream/90 max-w-3xl mx-auto" data-id="element-170">
            Seis plantillas Excel pre-hechas con fórmulas automáticas + guía en
            español. Basado en la regla 50/30/20 adaptada para solteras: 50%
            necesidades (renta, hijos), 30% deseos reales (remesas), 20%
            deudas/ahorro.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-171">
          {features.map((Feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 rounded-2xl text-center flex flex-col items-center gap-4" data-id="element-172">
              <div className="w-14 h-14 bg-gold rounded-full flex items-center justify-center text-charcoal" data-id="element-173">
                <Feature.icon className="w-7 h-7" data-id="element-174" />
              </div>
              <p className="font-medium text-lg" data-id="element-175">{Feature.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white text-charcoal p-8 rounded-3xl max-w-3xl mx-auto text-center shadow-2xl" data-id="element-176">
          <p className="text-xl mb-4" data-id="element-177">
            Hecho para Aldi/Walmart hacks, ingresos variables (gig income), y
            método snowball para deudas. Incluye ejemplos reales con salario de
            $2,800/mes.
          </p>
          <div className="inline-block bg-cream px-6 py-3 rounded-full border border-gold/30" data-id="element-178">
            <p className="font-bold text-purple-dark flex items-center gap-2" data-id="element-179">
              <span className="text-2xl" data-id="element-180">✨</span> Creado por mamá latina que
              pagó $3k deudas en 6 meses
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}